import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from "react-redux"
import { Dispatch } from '@reduxjs/toolkit';
import WOW from 'wowjs';
// components
import Logo from 'components/Logo';
// actions
import CoreAction from "core/actions/common/CoreAction";
import CMSAction from 'cms/actions/common/CMSAction';
import ContentMetricsServiceAction from "cms/actions/components/Header/ContentMetricsServiceAction";
// interfaces
import IClientLanguage from 'core/interfaces/IClientLanguage';
import IClientSiteSettingDetail from 'cms/interfaces/IClientSiteSettingDetail';
import HeaderMenu from './components/HeaderMenu';
import MobileMenu from './components/MobileMenu';
import { EContentMetricsType } from 'core/enums/EContentMetricsType';
import { isEmpty } from 'lodash';


function mapStateToProps ( state: any ) {
    console.log("Header.mapStateToProps: ", state);

    const languageStorePayload:IClientLanguage[]    = state.LanguageStore.list?.payload;

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const siteSettingDetailPayload:IClientSiteSettingDetail         = state.SiteSettingStore.details?.payload;

    return {

        languageStorePayload,

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        siteSettingDetailPayload,
        
    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("Header.mapDispatchToProps");

    const coreAction = new CoreAction(dispatch);
    const cmsAction = new CMSAction(dispatch);
    const contentMetricsServiceAction = new ContentMetricsServiceAction(dispatch);
    
    return {
        
        _viewEvent: ( contentId:string, webApplicationLanguageCode:string ) => {
            contentMetricsServiceAction.post({ 
                servicePayload: { 
                    body: {
                        contentId: contentId,
                        metricType: EContentMetricsType.VIEV
                    }, 
                    language: webApplicationLanguageCode 
                } 
            });
        },

        // 
        _openMobileMenu: () => {
            cmsAction.openMobileMenu();
        },

        _closeMobileMenu: () => {
            cmsAction.closeMobileMenu();
        },

        // other
        _hideLoader: () => { 
            coreAction.hideLoader(); 
        },

        _showLoader: () => { 
            coreAction.showLoader(); 
        }

    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>
type THeader<T> = {
    
    site_header?: {
        categoryMenu: {},
        menu: {}
    };

} & T;


/* component */
function HeaderLoader () {

    

    return (
        <>
            
        </>
    )

}

function Header ( props:THeader<PropsFromRedux> ) {
    console.log("Header.rendered:", props);
    
    const [ scroll, setScroll] = useState<boolean>(false);
    const [ isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false)

    useEffect(
        () => {
            new WOW.WOW({ live: false }).init();
            document.addEventListener("scroll", () => {
                const scrollCheck = window.scrollY > 100;
                setScroll(scrollCheck)
            })
        }, []
    )

    function viewEvent ( event:React.MouseEvent<HTMLDivElement|HTMLSpanElement>, contentId:string ) {
        if ( !isEmpty(contentId) ) {
            props._viewEvent( contentId, props.webApplicationLanguageCode )
        }
    }

    function handleMobileMenu ( event:React.MouseEvent<HTMLDivElement|HTMLSpanElement>, contentId:string ) {
        viewEvent( event, contentId );
        setIsMobileMenuOpen(!isMobileMenuOpen);
        !isMobileMenuOpen ? document.body.classList.add("mobile-menu-visible") : document.body.classList.remove("mobile-menu-visible")
    }

    return (
        <>
            <header className={`main-header-three ${scroll ? "fixed-header" : ""}`}>
                <nav className="main-menu main-menu-three">
                    <div className="main-menu-three__wrapper">
                        <div className="container">
                            <div className="main-menu-three__wrapper-inner">
                                <div className="main-menu-three__left">
                                    <div className="main-menu-three__logo">
                                        <Logo 
                                            siteSettingPayload={props.siteSettingDetailPayload} 
                                            webApplicationLanguageISOCode={props.webApplicationLanguageISOCode} 
                                        />
                                    </div>
                                </div>
                                <div className="main-menu-three__main-menu-box">
                                    <div className="mobile-nav__toggler tw-cursor-pointer" onClick={(event) => { handleMobileMenu(event, "") }}><i className="fa fa-bars"></i></div>
                                    <HeaderMenu onClick={viewEvent} />
                                </div>
                                {/* <div className="main-menu-three__right">
                                    <div className="main-menu-three__btn-box">
                                        <Link href="contact" className="main-menu-three__btn thm-btn">Get A quato</Link>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            <MobileMenu onClick={handleMobileMenu} />
            
            <div className={`stricky-header stricked-menu main-menu main-menu-three ${scroll ? "stricky-fixed" : ""}`}>
                <div className="sticky-header__content">
                    <nav className="main-menu main-menu-three">
                        <div className="main-menu-three__wrapper">
                            <div className="container">
                                <div className="main-menu-three__wrapper-inner">
                                    <div className="main-menu-three__left">
                                        <div className="main-menu-three__logo">
                                            <Logo siteSettingPayload={props.siteSettingDetailPayload} webApplicationLanguageISOCode={props.webApplicationLanguageISOCode} />
                                        </div>
                                    </div>
                                    <div className="main-menu-three__main-menu-box">
                                        <div className="mobile-nav__toggler tw-cursor-pointer" onClick={(event) => { handleMobileMenu(event, "") }}><i className="fa fa-bars"></i></div>
                                        <HeaderMenu onClick={viewEvent}/>
                                    </div>
                                    {/* <div className="main-menu-three__right">
                                        <div className="main-menu-three__btn-box">
                                            <Link href="contact" className="main-menu-three__btn thm-btn">Get A quato</Link>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    );
    
}

const Component = React.memo(Header, ( prevProps:THeader<PropsFromRedux>, nextProps:THeader<PropsFromRedux> ) => {
    console.log("Header.memo", { prevProps, nextProps });

    return !( 
        prevProps.webApplicationLanguage !== nextProps.webApplicationLanguage
        || prevProps.siteSettingDetailPayload !== nextProps.siteSettingDetailPayload
    );
});

export default connector(Component);
